export const BLOCK_TITLE = 'TITLE';
export const BLOCK_BODY = 'BODY';
export const BLOCK_MEDIA = 'MEDIA';
export const BLOCK_USER = 'USER';
export const BLOCK_LABEL = 'LABEL';
export const BLOCK_PRIMARY_CTA = 'PRIMARY_CTA';
export const BLOCK_SECONDARY_CTA = 'SECONDARY_CTA';
export const BLOCK_STEPPER = 'STEPPER';
export const BLOCK_CHOICE = 'CHOICE';
export const BLOCK_SLIDER = 'SLIDER';
export const BLOCK_NPS = 'NPS';
export const BLOCK_OPINION = 'OPINION';
export const BLOCK_INTERVIEW = 'INTERVIEW';
export const BLOCK_OPEN_QUESTION = 'OPEN_QUESTION';
export const BLOCK_ANIMATION = 'ANIMATION';
export const BLOCK_CONCEPT = 'CONCEPT';
export const BLOCK_JIMO_LABEL = 'JIMO_LABEL';
export const BLOCK_HINT = 'HINT';
export const BLOCK_DISMISS_CROSS = 'DISMISS_CROSS';
export const BLOCK_CURSOR = 'CURSOR';
export const BLOCK_HOTSPOT = 'HOTSPOT';
export const BLOCK_VISUAL_CUE = 'VISUAL_CUE';

// Checklist
export const BLOCK_CHECKLIST_HEADER = 'CHECKLIST_HEADER';
export const BLOCK_CHECKLIST_HEADER_TITLE = 'CHECKLIST_HEADER_TITLE';
export const BLOCK_CHECKLIST_HEADER_DESCRIPTION =
  'CHECKLIST_HEADER_DESCRIPTION';
export const BLOCK_CHECKLIST_HEADER_PROGRESS = 'CHECKLIST_HEADER_PROGRESS';
export const BLOCK_CHECKLIST_HEADER_CONTROL = 'CHECKLIST_HEADER_CONTROL';
export const BLOCK_CHECKLIST_TASK_LIST = 'CHECKLIST_TASK_LIST';
export const BLOCK_CHECKLIST_TASK_ITEM = 'CHECKLIST_TASK_ITEM';
export const BLOCK_CHECKLIST_TASK_CHECKBOX = 'CHECKLIST_TASK_ITEM_CHECKBOX';
export const BLOCK_CHECKLIST_TASK_ITEM_TITLE = 'CHECKLIST_TASK_ITEM_TITLE';
export const BLOCK_CHECKLIST_TASK_ITEM_DESCRIPTION =
  'CHECKLIST_TASK_ITEM_DESCRIPTION';
export const BLOCK_CHECKLIST_TASK_ITEM_MEDIA = 'CHECKLIST_TASK_ITEM_MEDIA';
export const BLOCK_CHECKLIST_TASK_ITEM_PRIMARY_CTA =
  'CHECKLIST_TASK_ITEM_PRIMARY_CTA';
export const BLOCK_CHECKLIST_TASK_ITEM_SECONDARY_CTA =
  'CHECKLIST_TASK_ITEM_SECONDARY_CTA';
export const BLOCK_CHECKLIST_TRIGGER = 'CHECKLIST_TRIGGER';
export const BLOCK_CHECKLIST_DISMISS = 'CHECKLIST_DISMISS';

// Resource Center
export const BLOCK_RESOURCE_CENTER_HEADER = 'RESOURCE_CENTER_HEADER';
export const BLOCK_RESOURCE_CENTER_TITLE = 'RESOURCE_CENTER_TITLE';
export const BLOCK_RESOURCE_CENTER_SUBTITLE = 'RESOURCE_CENTER_SUBTITLE';
export const BLOCK_RESOURCE_CENTER_MINIMIZE = 'RESOURCE_CENTER_MINIMIZE';
export const BLOCK_RESOURCE_CENTER_ACTION = 'RESOURCE_CENTER_ACTION';
export const BLOCK_RESOURCE_CENTER_GROUP = 'RESOURCE_CENTER_GROUP';
export const BLOCK_RESOURCE_CENTER_ACTION_TITLE =
  'RESOURCE_CENTER_ACTION_TITLE';
export const BLOCK_RESOURCE_CENTER_ACTION_PARAGRAPH =
  'RESOURCE_CENTER_ACTION_PARAGRAPH';
export const BLOCK_RESOURCE_CENTER_ACTION_MEDIA =
  'RESOURCE_CENTER_ACTION_MEDIA';
export const BLOCK_RESOURCE_CENTER_ACTION_ICON = 'RESOURCE_CENTER_ACTION_ICON';
export const BLOCK_RESOURCE_CENTER_ACTION_CTA = 'RESOURCE_CENTER_ACTION_CTA';
export const BLOCK_RESOURCE_CENTER_GROUP_TITLE = 'RESOURCE_CENTER_GROUP_TITLE';
export const BLOCK_RESOURCE_CENTER_TRIGGER = 'RESOURCE_CENTER_TRIGGER';
export const BLOCK_RESOURCE_CENTER_TRIGGER_ICON =
  'RESOURCE_CENTER_TRIGGER_ICON';
export const BLOCK_RESOURCE_CENTER_TRIGGER_TEXT =
  'RESOURCE_CENTER_TRIGGER_TEXT';
export const BLOCK_RESOURCE_CENTER_TRIGGER_ARROW =
  'RESOURCE_CENTER_TRIGGER_ARROW';
export const BLOCK_RESOURCE_CENTER_EMBEDDED_CHECKLIST =
  'RESOURCE_CENTER_EMBEDDED_CHECKLIST';
export const BLOCK_RESOURCE_CENTER_TRIGGER_CHECKLIST_PROGRESS =
  'RESOURCE_CENTER_TRIGGER_CHECKLIST_PROGRESS';
export const BLOCK_RESOURCE_CENTER_ASK_AI = 'RESOURCE_CENTER_ASK_AI';
export const BLOCK_RESOURCE_CENTER_ASK_AI_AI_NAME =
  'RESOURCE_CENTER_ASK_AI_AI_NAME';
export const BLOCK_RESOURCE_CENTER_ASK_AI_USER_BUBBLE_CHAT =
  'RESOURCE_CENTER_ASK_AI_USER_BUBBLE_CHAT';
export const BLOCK_RESOURCE_CENTER_ASK_AI_AI_BUBBLE_CHAT =
  'RESOURCE_CENTER_ASK_AI_AI_BUBBLE_CHAT';
export const BLOCK_RESOURCE_CENTER_ASK_AI_CALL_TO_ACTION =
  'RESOURCE_CENTER_ASK_AI_CALL_TO_ACTION';
export const BLOCK_RESOURCE_CENTER_ASK_AI_RESPONSE_ACTIONS =
  'RESOURCE_CENTER_ASK_AI_RESPONSE_ACTIONS';
export const BLOCK_RESOURCE_CENTER_ASK_AI_SOURCES =
  'RESOURCE_CENTER_ASK_AI_SOURCES';
export const BLOCK_RESOURCE_CENTER_ASK_AI_SOURCES_TITLE =
  'RESOURCE_CENTER_ASK_AI_SOURCES_TITLE';
export const BLOCK_RESOURCE_CENTER_ASK_AI_SOURCE =
  'RESOURCE_CENTER_ASK_AI_SOURCE';
export const BLOCK_RESOURCE_CENTER_ASK_AI_SOURCE_TEXT =
  'RESOURCE_CENTER_ASK_AI_SOURCE_TEXT';
export const BLOCK_RESOURCE_CENTER_ASK_AI_SOURCE_ICON =
  'RESOURCE_CENTER_ASK_AI_SOURCE_ICON';
export const BLOCK_RESOURCE_CENTER_ASK_AI_SOURCE_CTA =
  'RESOURCE_CENTER_ASK_AI_SOURCE_CTA';
export const BLOCK_RESOURCE_CENTER_ASK_AI_REPLY_BAR =
  'RESOURCE_CENTER_ASK_AI_REPLY_BAR';
export const BLOCK_RESOURCE_CENTER_ASK_AI_REPLY_BAR_BUTTON =
  'RESOURCE_CENTER_ASK_AI_REPLY_BAR_BUTTON';
export const BLOCK_RESOURCE_CENTER_ASK_AI_TRIGGER_INPUT =
  'RESOURCE_CENTER_ASK_AI_TRIGGER_INPUT';
export const BLOCK_RESOURCE_CENTER_ASK_AI_TRIGGER_INPUT_BUTTON =
  'RESOURCE_CENTER_ASK_AI_TRIGGER_INPUT_BUTTON';

export const BLOCK_FLAG_CHOICE_CAN_MULTIPLE = 2;

export const getDefaultResponseForStep = (step) => {
  const blockInteractive = step.blocks.find(
    (b) => isInteractiveBlock(b.type) === true
  );

  if (blockInteractive == null) {
    return undefined;
  }
  return getDefaultResponseForBlock(blockInteractive.type);
};

export const getDefaultResponseForBlock = (blockType) => {
  switch (blockType) {
    case BLOCK_CHOICE:
      return [];
    case BLOCK_SLIDER:
      return '';
    case BLOCK_OPEN_QUESTION:
      return '';
    case BLOCK_OPINION:
      return '';
    case BLOCK_NPS:
      return '';
    default:
      return undefined;
  }
};

export const isInteractiveBlock = (type) => {
  return [
    BLOCK_NPS,
    BLOCK_CHOICE,
    BLOCK_OPEN_QUESTION,
    BLOCK_SLIDER,
    BLOCK_OPINION,
  ].includes(type);
};
